module.exports = __webpack_public_path__ + "img/01_NEW.04cee389.png";